export default "__VITE_ASSET__509b4d8e__"